import React from 'react'
import { motion } from "framer-motion"
function Loading() {
  return (
    <div className='flex justify-center items-center'>
       
       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        style={{ width: 50, height: 50, borderRadius: '50%', border: '5px solid #ff0000', borderLeftColor: 'transparent', borderTopColor: 'transparent' }}
      />
    </div>
       
       </div>
  )
}

export default Loading
